import { render, staticRenderFns } from "./CanAccess.vue?vue&type=template&id=1db27150&"
import script from "./CanAccess.vue?vue&type=script&lang=js&"
export * from "./CanAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports